import * as React from 'react';
import { SchoolEvent } from '../../../../../../models/event';
import { Field, Form, Formik } from 'formik';
import { VENUE_DISTANCE, VENUE_DISTANCE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/venue';
import * as Yup from 'yup';
import { Autocomplete } from '../../../../../../components/Autocomplete/Autocomplete';
import { getName, searchFunctionEventAddOrChangeSchool } from '../../../../../../helpers/autocomplete/autocomplete';
import { AppUser } from '../../../../../App/App';
import './SchoolEventAddSchoolForm.scss';

interface Props {
  event: SchoolEvent;
  user: AppUser;
  onCancel: () => void;
  onSubmit: (schoolId: string) => void;
}

interface State {
  distance: number;
}

const initialValues = {
  schoolId: '',
  school: undefined
};

const validationSchema = Yup.object().shape({
  schoolId: Yup.string().required('Required')
});

export class SchoolEventAddSchoolForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      distance: VENUE_DISTANCE.UNLIMITED
    };
  }
  getSchools = (text: string) => {
    const { user, event } = this.props;
    const { distance } = this.state;

    return searchFunctionEventAddOrChangeSchool(text, user, event, distance);
  };

  render() {
    const { onCancel, onSubmit } = this.props;
    const { distance } = this.state;

    return (
      <div className="eAddSchoolForm">
        <p className="eAddSchoolForm__intro">
          Add another participating school to this event. Use the distance limit to narrow the search.
        </p>

        <div className="eAddSchoolForm__field">
          <label className="eAddSchoolForm__label" htmlFor="event-add-school-distance">
            Maximum distance
          </label>
          <select
            id="event-add-school-distance"
            value={distance}
            className="form-control eAddSchoolForm__control"
            onChange={event => {
              this.setState({
                distance: Number(event.target.value)
              });
            }}
          >
            <option value={VENUE_DISTANCE.UNLIMITED}>{VENUE_DISTANCE_SERVER_TO_CLIENT_MAPPING.UNLIMITED}</option>
            <option value={VENUE_DISTANCE['10M']}>{VENUE_DISTANCE_SERVER_TO_CLIENT_MAPPING['10M']}</option>
            <option value={VENUE_DISTANCE['20M']}>{VENUE_DISTANCE_SERVER_TO_CLIENT_MAPPING['20M']}</option>
            <option value={VENUE_DISTANCE['30M']}>{VENUE_DISTANCE_SERVER_TO_CLIENT_MAPPING['30M']}</option>
            <option value={VENUE_DISTANCE['40M']}>{VENUE_DISTANCE_SERVER_TO_CLIENT_MAPPING['40M']}</option>
            <option value={VENUE_DISTANCE['50M']}>{VENUE_DISTANCE_SERVER_TO_CLIENT_MAPPING['50M']}</option>
          </select>
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={data => {
            const { schoolId } = data;
            onSubmit(schoolId);
          }}
        >
          {({ values, setFieldValue, touched, errors }) => (
            <Form>
              <div className="eAddSchoolForm__field">
                <label className="eAddSchoolForm__label">
                  School <span>*</span>
                </label>
                <Field name="participants">
                  {() => (
                    <Autocomplete
                      searchFunction={this.getSchools}
                      getElementTitle={getName}
                      customClass="mFullWidth"
                      debounceMs={180}
                      defaultItem={values.school}
                      placeholder="Search by school name"
                      isItemWithImage={true}
                      onSelect={school => {
                        setFieldValue('school', school);
                        setFieldValue('schoolId', school.id);
                      }}
                    />
                  )}
                </Field>
                {touched.schoolId && errors.schoolId ? (
                  <div className="eAddSchoolForm__error">{errors.schoolId}</div>
                ) : null}
              </div>

              <div className="eAddSchoolForm__actions">
                <button type="button" className="btn eAddSchoolForm__cancel" onClick={onCancel}>
                  Cancel
                </button>
                <button type="submit" className="btn eAddSchoolForm__save">
                  Add school
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}
